import acRepair from '@/assets/services/ac-repair.png';
import electrician from '@/assets/services/electrician.png';
import plumber from '@/assets/services/plumber.png';
import cleaning from '@/assets/services/cleaning.png';
import beautician from '@/assets/services/beautician.png';
import cook from '@/assets/services/cook.png';
import maid from '@/assets/services/maid.png';
import caretaker from '@/assets/services/caretaker.png';
import painting from '@/assets/services/painting.png';
import laundry from '@/assets/services/laundry.png';
import pestControl from '@/assets/services/pest-control.png';
import appliances from '@/assets/services/appliances.png';

// Supports both old numeric IDs and new UUIDs
export const serviceImages: Record<string, string> = {
  '1': acRepair,
  '2': electrician,
  '3': plumber,
  '4': cleaning,
  '5': beautician,
  '6': cook,
  '7': maid,
  '8': caretaker,
  '00000000-0000-0000-0000-000000000001': acRepair,
  '00000000-0000-0000-0000-000000000002': electrician,
  '00000000-0000-0000-0000-000000000003': plumber,
  '00000000-0000-0000-0000-000000000004': cleaning,
  '00000000-0000-0000-0000-000000000005': beautician,
  '00000000-0000-0000-0000-000000000006': cook,
  '00000000-0000-0000-0000-000000000007': maid,
  '00000000-0000-0000-0000-000000000008': caretaker,
  '00000000-0000-0000-0000-000000000009': painting,
  '00000000-0000-0000-0000-000000000010': pestControl,
  '00000000-0000-0000-0000-000000000011': laundry,
  '00000000-0000-0000-0000-000000000012': appliances,
  // Slug-based mapping for foolproof resolution
  'ac-repair': acRepair,
  'electrician': electrician,
  'plumber': plumber,
  'cleaning': cleaning,
  'beautician': beautician,
  'cook': cook,
  'maid': maid,
  'caretaker': caretaker,
  'painting': painting,
  'laundry': laundry,
  'pest-control': pestControl,
  'appliances': appliances,
};
